import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { UserBehaviorRisksAppWebComponentSchema } from '../types';

export class UserBehaviorRisksAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<UserBehaviorRisksAppWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
